export const fetchConditionalPropertyRules = (objectTypeId, httpClient, query) => {
  var _query$includeAssocia;
  return httpClient.get(`conditional-properties/v2/unified-rules`, {
    query: Object.assign({
      objectTypeId,
      pageSize: 100,
      includeActualConditionalPropertyRules: true,
      includeAssociationFields: (_query$includeAssocia = query === null || query === void 0 ? void 0 : query.includeAssociationFields) !== null && _query$includeAssocia !== void 0 ? _query$includeAssocia : false
    }, query)
  }).then(response => {
    const {
      results,
      offset: newOffset,
      hasMore
    } = response;
    if (hasMore) {
      return fetchConditionalPropertyRules(objectTypeId, httpClient, Object.assign({}, query, {
        offset: newOffset
      })).then(rules => results.concat(rules));
    }
    return results;
  });
};